import gql from 'graphql-tag';

const getPhotoFinderCreditItems = gql`
  query photoFinderCreditItems {
    photoFinderCreditItems {
      id
      amount
      price {
        value
      }
    }
  }
`;

export default getPhotoFinderCreditItems;
